import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=422d8142&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports